__turbopack_context__.v({
  "showAllAgendaButton": "ShowAllButton-module-scss-module__em-X_q__showAllAgendaButton",
});
